import AWS, { AWSError } from 'aws-sdk';
import { ManagedUpload } from 'aws-sdk/clients/s3';
import FileStorage from '@/entities/FileStorage';

interface S3config {
	accessKeyId: string;
	secretAccessKey: string;
}
interface DevStorageConstructor {
	S3bucketURL: string;
	S3config: S3config;
}

export default class DevStorage implements FileStorage {
	private storage: AWS.S3;
	private S3bucketURL: string;

	// constructor({ S3bucketURL, S3config }: DevStorageConstructor) {
	//   AWS.config.update(S3config);
	//   this.S3bucketURL = S3bucketURL;
	//   this.storage = new AWS.S3({ endpoint: "https://s3.amazonaws.com/" });
	// }

	constructor({ S3bucketURL, S3config }: DevStorageConstructor) {
		const s3endpoint = process.env.VUE_APP_LOCAL_S3_ENDPOINT;
		// AWS.config.update(S3config);
		this.S3bucketURL = S3bucketURL;
		this.storage = new AWS.S3({
			credentials: S3config,
			endpoint: s3endpoint ? s3endpoint : 'https://s3.amazonaws.com/',
			s3ForcePathStyle: true,
			s3BucketEndpoint: false,
		});
	}

	async get(fileName: string): Promise<string> {
		return await this.storage.getSignedUrl('getObject', {
			Bucket: this.S3bucketURL,
			Key: fileName,
		});
	}

	save(
		fileName: string,
		fileData: Buffer,
		onProgress: (progress: number) => void
	): Promise<AWS.S3.ManagedUpload.SendData | AWS.AWSError> {
		const upload = new ManagedUpload({
			service: this.storage,
			params: {
				Bucket: this.S3bucketURL,
				Key: fileName,
				Body: fileData,
			},
		});
		upload.on('httpUploadProgress', (progress) => {
			if (progress.total) {
				const percentage = Math.round(
					(progress.loaded / progress.total) * 100
				);
				onProgress(percentage);
			}
		});
		return new Promise((resolve, reject) => {
			upload.send((error, data) => {
				if (error) {
					reject(error);
				} else {
					resolve(data);
				}
			});
		});
	}

	delete(
		fileName: string
	): Promise<AWS.AWSError | AWS.S3.DeleteObjectOutput> {
		return new Promise<AWS.S3.DeleteObjectOutput | AWS.AWSError>(
			(resolve, reject) => {
				this.storage.deleteObject(
					{
						Bucket: this.S3bucketURL,
						Key: fileName,
					},
					(error: AWSError, data: AWS.S3.DeleteObjectOutput) => {
						if (error) {
							throw reject(error);
						}
						return resolve(data);
					}
				);
			}
		);
	}
}
